import React from "react";
import i_back from "../../UI/back_simple.png";
import AmenidadButton from "../ui/AmenidadButton";

const BarAmenidadesComponent = ({ProyectoAmenidades, handleClickButton, stateBtnSelected,icons}) => {
    return(
        <div className = "amenidades-sidebar">
            <div className = "sidebar-amenidades">
                {
                ProyectoAmenidades.map((amenity, indexAmenity) =>
                    <>
                    <AmenidadButton
                        nombre = {amenity.Nombre}
                        icono = {icons}
                        handleClickButton = {handleClickButton}
                        stateBtnSelected = {stateBtnSelected}
                    />
                    </>                    
                )
                }
                
            </div>
        </div>
    );
};

export default BarAmenidadesComponent;